export default "__VITE_ASSET__Wqxaf2Do__"